<template>
    <div style="height:calc(100%);">
        <el-header> <common-header2 /></el-header>
        <div style="height:calc(100% - 72px);">
            <el-card style="overflow: hidden auto; height: 100%;">
                <el-form ref="form" :model="form" :inline="true" size="small" label-width="100px">
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="10">
                            <el-form-item label="教程種類">
                                {{ form.tutorial_cate }}
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="10">
                            <el-form-item label="教程子類">
                                {{ form.tutorial_sub_cate }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="10">
                            <el-form-item label="教程名稱">
                                {{ form.name }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <label class="el-form-item__label" style="width: 100px;">備註</label>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <div class="el-form-item__content" style="width: 100%;">
                                <div v-html="form.remark"></div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="form.capture_id != null">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <label class="el-form-item__label" :style="'width:' + UploadCtlLeft">圖片</label>
                            <UploadFile :showID="form.capture_id" :controlID="'main_capture_id'" ref="main_File"
                                :style="'margin-left:' + UploadCtlLeft" :hideUploadBtn="true" />
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <hr />
                        </el-col>
                    </el-row>
                </el-form>
                <!--明細表-->
                <el-form label-position="right" :inline="true" label-width="100px" size="small">
                    <div v-for="(props, index) in form.detail" :key="index"
                        :style="'clear: both; ' + (index % 2 == 0 ? 'background-color: #f0f9eb; ' : '')">
                        <el-row>
                            <div style="font-weight: bold; width: 88px; text-align: right;">步驟{{ index + 1 }}</div>
                        </el-row>
                        <el-row>
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item label="步驟説明">
                                    <div v-html="crlf2Br(props.detail)"></div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <label class="el-form-item__label" style="width: 100px;">步驟備註</label>
                                <div class="el-form-item__content" style="width: calc(100% - 105px);">
                                    <div v-html="props.remark"></div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row v-if="props.capture_id != null">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <label class="el-form-item__label" :style="'width:' + UploadCtlLeft"
                                    :key="'ImgLabel' + index">圖片</label>
                                <UploadFile :showID="props.capture_id" :controlID="'sub_capture_id1'" ref="sub_File1"
                                    :style="'margin-left:' + UploadCtlLeft" :key="'Img' + index"
                                    :hideUploadBtn="true" />
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </el-card>
        </div>
    </div>
</template>
<script>
import commonHeader2 from "@/components/commonHeader.vue";

import { directOpenItem } from "@/api/rms86/job_tutorial";
import UploadFile from "@/components/form/uploadFile_direct.vue";

export default {
    name: "JobTutorial_view",
    components: { commonHeader2, UploadFile }, //
    data() {
        return {
            loading: false, // 默认保存按钮不加载
            form: {
                id: null,
                name: "",
                template_sub_cate_id: null,
                template_sub_cate: "",
                template_cate_id: null,
                template_cate: "",
                active: true,
                remark: '',
                capture_id: null,
                detail: []
            },
            UploadCtlLeft: '130px',
            screenWidth: "",
            screenHeight: "",
        };
    },
    methods: {
        // 获取修改数据
        async EditInfo() {
            this.form.id = this.$route.query.id;
            var data = await directOpenItem({
                params: {
                    para: this.$route.query.para,
                },
            });
            if (data.success == 1)
                this.form = data.data;
            else
                this.$message.error(data.message);
        },
        calcLabelWidth(val) {
            var result = "130px;";
            if (val < 550) {
                var m = (val - 228) / 2;
                if (m > 60) {
                    result = m + "px";
                }
                else {
                    result = "60px";
                }
            }
            this.UploadCtlLeft = result;
        },
        crlf2Br(str) {
            var regR = /\r/g;
            var regN = /\n/g;
            return str.replace(regR, "").replace(regN, "<br />");
        },
        // 檢查是否手機微信瀏覽器
        checkWechatBrowser() {
            if (/(micromessenger)/i.test(navigator.userAgent)) {
                //是否电脑微信或者微信开发者工具
                if (/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)) {
                    //pc微信要設置這行, 否則滾動會亂
                    this.screenHeight = parseInt(document.body.clientHeight - 103) + "px";
                } else {
                    //手机微信
                    this.screenHeight = parseInt(document.body.clientHeight - 103) + "px";
                }
            } else {
                this.screenHeight = parseInt(document.body.clientHeight - 103) + "px";
            }
            this.screenWidth = parseInt(document.body.clientWidth - 103) + "px";
        },
    },
    async mounted() {
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
                this.screenHeight = document.body.clientHeight;
            })();
        };
        this.screenWidth = document.body.clientWidth;
        await this.EditInfo();
    },
    updated() {
        this.SetFontSize(this.$store.getters.size);
        this.calcLabelWidth(this.screenWidth);
    },
    watch: {
        screenWidth: {
            handler(val) {
                this.calcLabelWidth(val);
            },
        },
    },
};
</script>
<style lang="less" scoped>
:deep .el-card__body {
    padding-right: 0px;
}

:deep .el-form-item__label {
    padding-right: 10px;
}

:deep .el-form-item__content {
    margin-left: 5px;
}
/deep/ p {
    overflow: auto;
}
</style>